import { TGetMatchOutputDto } from "@/api/services/main/match/dtos/get-match.dto";
import { TUpdateMatchReqDto } from "@/api/services/main/match/dtos/update-match.dto";
import { DATE_FORMAT_FOR_API } from "@/constants/datetime";
import { TMatchForm, TMatchOffice } from "@/features/match/types/MatchForm";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import dayjs from "dayjs";

export const convertMatchRes = (match?: TGetMatchOutputDto): Partial<TMatchInfo> => {
  return {
    matchName: match?.matchName ?? "",
    licenseNumber: match?.licenseNumber ?? "",
    zipCode: match?.zipCode ?? "",
    address: match?.address ?? "",
    prefecture: match?.prefecture ?? "",
    city: match?.city ?? "",
    contractStatus: match?.contractStatus ?? "",
    contractStartDate: match?.contractStartDate ? dayjs(match.contractStartDate) : null,
    trialStartDate: match?.trialStartDate ? dayjs(match.trialStartDate) : null,
    trialEndDate: match?.trialEndDate ? dayjs(match.trialEndDate) : null,
    contractEndDate: match?.contractEndDate ? dayjs(match.contractEndDate) : null,
    matchOffices: match?.matchOffices?.map((office) => ({ ...office, trainingDate: office.trainingDate ? dayjs(office.trainingDate) : null })) ?? [],
  };
};

export const convertMatchReq = (data: TMatchForm): TUpdateMatchReqDto => {
  return {
    matchName: data.matchName,
    zipCode: data.zipCode,
    address: data.address,
    prefecture: data.prefecture,
    city: data.city,
    matchOffices:
      data.matchOffices?.map(
        (office) =>
          ({
            ...office,
            trainingDate: office.trainingDate ? dayjs(office.trainingDate).format(DATE_FORMAT_FOR_API) : null,
          }) as TMatchOffice,
      ) ?? [],
  };
};
